// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__LtlPs","fileBtn":"File_fileBtn__CvmRc","closeBtn":"File_closeBtn__wXSgO","fileSelected":"File_fileSelected__kyxsV","disabled":"File_disabled__1E61J"};